<template>
  <div class="visualizer pt-5 mt-5 px-4">
    <div class="h-100 mt-5 w-auto" dir="ltr">
      <vue-slider
        v-model="yearRangeVals"
        :enable-cross="false"
        :clickable="false"
        :dragOnClick="false"
        :minRange="-200"
        :max="2000"
        :min="-200"
        :tooltip="singleClicked ? 'none' : 'always'"
        :marks="yearRange"
        :dotSize="20"
        :height="8"
        class="top-slider"
        :class="{ 'single-slider': singleClicked }"
        @drag-end="emitValue"
        ref="slider"
      >
      </vue-slider>
      <vue-slider
        class="year-marker"
        :dragOnClick="false"
        v-model="value2"
        :marks="yearArr"
        :minRange="-200"
        :min="-200"
        :dotSize="0"
        height="0"
        :max="2000"
        included
        ref="yearSlider"
        :tooltip="'active'"
      >
        <template v-slot:step="{ label, active, value }">
          <div
            class="custom-step position-relative"
            :class="{
              active: value2 == parseInt(value),
              xdisabled:
                parseInt(value) < parseInt(yearRangeVals[0]) ||
                parseInt(value) > parseInt(yearRangeVals[1]),
            }"
          ></div>
        </template>
        <template v-slot:tooltip="{ value, click }">
          <div :class="['custom-tooltip', { click }]">
            <div
              v-for="(tooltipItem, l) in groupedData[parseInt(value)]"
              :key="'tooltipData' + l"
            >
              <div class="d-inline-block">{{ tooltipItem.title }}</div>
              <small class="d-inline-block mx-1 text-muted">{{
                tooltipItem.city
              }}</small>
              <small class="d-inline-block text-muted">{{
                tooltipItem.location
              }}</small>
              <span
                v-if="!isNaN(tooltipItem.year)"
                class="rounded-pill text-muted px-1 d-inline-block"
                :class="hebrew ? 'mr-1' : 'ml-1'"
              >
                {{ tooltipItem.year }}
              </span>
              <hr
                v-if="
                  groupedData[parseInt(value)].length > 1 &&
                  l < groupedData[parseInt(value)].length - 1
                "
              />
            </div>
          </div>
        </template>
        <template v-slot:label="{ label, active }">
          <div
            :class="[
              'vue-slider-mark-label book-count text-center rounded-circle position-relative',
              'custom-label',
              { active },
            ]"
          >
            {{ groupedData[parseInt(label)].length }}
          </div>
        </template>
      </vue-slider>
      <!--<small class="d-block text-muted position-relative" v-if="singleClicked" style="top:180px;">
        {{hebrew ? 'כדי לערוך את טווח השנים, יש לגשת לציר הזמן הראשי הנמצא בשורת הכותרת ״מקבילות״' : 'To filter the range by years, access the timeline via the button above the resutls.'}}
      </small>  
      -->
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component"
import "vue-slider-component/theme/default.css"
import _ from "lodash"
export default {
  name: "Visualizer",
  components: { VueSlider },
  props: ["metaData", "singleClicked", "range"],
  data() {
    return {
      timelineData: [],
      groupedData: {},
      yearArr: [],
      yearRange: [
        -200, 0, 200, 400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000,
      ],
      yearRangeVals: [-200, 2000],
      value2: 0,
    }
  },
  mounted() {
    this.setRange()
    this.flatData()
  },
  methods: {
    setRange() {
      if (this.range.length > 1) {
        this.$refs.slider.setValue(this.range)
      } // else {
      //  this.$refs.slider.setValue([this.$store.state.filterData.fromYear, this.$store.state.filterData.toYear])
      // }
    },
    emitValue() {
      //let resultsNum = this.timelineData.filter (
      //  item => (item.Year >= this.yearRangeVals[0] &&  item.Year <= this.yearRangeVals[1])).length
      //this.$emit('year-range', {range: this.yearRangeVals, resultsLength: resultsNum})
    },
    flatData() {
      this.timelineData = this.metaData.filter((item) => item.year !== "")
      this.timelineData = _.uniqWith(this.timelineData, _.isEqual) //remove complete duplicates
      this.groupedData = _.groupBy(this.timelineData, function (data) {
        return data.year //.replace('.birth','');
      })
      this.yearArr = Object.keys(this.groupedData)
    },
  },
  computed: {
    hebrew() {
      return this.$settings.hebrew
    },
  },
}
</script>
<style lang="scss">
.vue-slider-dot {
  z-index: 0;
}
.custom-step {
  width: 100%;
  height: 100%;
  padding: 6px;
  border: 2px solid var(--primary);
  border-radius: 50%;
  //box-shadow: 0 0 0 6px #ccc;
  background-color: #fff;
  left: 50%;
  transform: translateX(-50%);

  &:hover {
    cursor: pointer;
  }
  &.disabled {
    border-color: #d6ecff;
    pointer-events: none;
  }
}
.custom-step.active {
  box-shadow: 0px 0px 0px 4px rgba(0, 126, 229, 0.5);
  z-index: 5;
}
.top-slider {
  &.single-slider {
    .vue-slider-dot {
      display: none;
    }
  }
  .vue-slider-dot {
    &:last-child {
      .vue-slider-dot-handle {
        transform: scaleX(-1);
      }
    }
  }
  .vue-slider-dot-handle {
    background: url("../assets/img/Flag.svg") center center no-repeat;
    background-size: contain;
    height: 28px;
    width: 16px;
    box-shadow: none;
    border-radius: 0;
    position: relative;
    top: -5px;
    display: none;
  }
}
.vue-slider-dot-handle-focus {
  box-shadow: none;
}
.vue-slider-mark-label.book-count {
  margin-top: 33px !important;
  width: 22px;
  background-color: #e3e3e3;
  height: 22px;
  font-size: 13px;
  color: #8d8d8d;
  &:before {
    content: "";
    position: absolute;
    width: 2px;
    height: 33px;
    background: rgba(222, 222, 222, 0.6);
    top: -33px;
    z-index: 2;
    left: 10px;
    //left: 50%;
    //transform: translateX(50%);
  }
}
.vue-slider-dot-handle {
  box-shadow: none;
}
.custom-tooltip {
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.21);
  direction: rtl;
  font-size: 14px;
  width: 330px;
  border-radius: 8px;
  text-align: right;
  color: #000;
  max-width: 350px;
  padding: 14px 14px;
  background-color: #fff;
  max-height: 200px;
  overflow-y: scroll;
  .rounded-pill {
    background: #d6ecff;
    line-height: 16px;
    font-size: 12px;
  }
  small {
    font-size: 12px;
  }
  hr {
    margin-top: 10px;
    margin-bottom: 10px;
    border: 0;
    border-top: solid 1px #d8d8d8;
  }
}
.year-marker {
  top: -22px;
  &.vue-slider {
    height: 0;
  }
  .vue-slider-dot.vue-slider-dot-hover {
    transition: opacity 0.5s ease 0s !important;
  }
}
.vue-slider-ltr .vue-slider-mark-step {
  display: none;
}
.vue-slider-marks {
  width: 1038px !important;
  margin: auto;
}
.vue-slider-rail {
  background-color: #d6ecff;
  background-color: #007ee5;
}
.vue-slider-process {
  background-color: #007ee5;
  height: 0;
}
.vue-slider-dot-tooltip-inner {
  //display: none;
  border-radius: 4px;
  border: solid 1px #000000;
  font-size: 12px;
  padding: 1px 8px;
  background-color: #ffffff;
  color: #000;
  &:after {
    border: none !important;
  }
}
</style>
